import {type TableCellProps} from '@mui/material';
import {type FishGroup, type ForecastGetColumnsEnum} from 'client';
import {type CellActionType, type methodType} from 'interfaces';
import {type MouseEvent} from 'react';

export interface ICellConcessionMABData {
  biomass: number;
  mab: number;
  delta: number;
}
export type INumberDictionary<TValue> = Record<number, TValue>;

export interface FixedTableCellProps extends TableCellProps {
  first?: boolean;
  xIndex: number;
  yIndex?: number;
  header?: boolean;
  pointer?: boolean;
  isQuality?: boolean;
  editable?: boolean;
  borderBottom?: boolean;
  invalid?: boolean;
  last?: boolean;
}

export interface StyledTableCellProps extends TableCellProps {
  header?: boolean;
  yIndex?: number;
  pointer?: boolean;
  outlineOnHover?: boolean;
  isWeekend?: boolean;
  isQuality?: boolean;
  bBottom?: boolean;
  faded?: boolean;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export declare type ForecastDataPoint = {[key in ForecastGetColumnsEnum]?: number};

export declare type ForecastPoint = [number, ForecastDataPoint];
declare type UtilizationColorName = 'success' | 'error' | 'warning';
declare type CellActionChangeType = methodType.edit | methodType.delete;
declare type CageCellClick = (event: MouseEvent<HTMLElement>) => void;

export interface CellAction {
  id: string;
  dateObject: Date;
  cageId: string;
  rawActionType?: string;
}

export interface CellActionCageData extends CellAction {
  weight?: number;
  count?: number;
  biomass?: number;
}

interface CellActionTupple {
  actionType: CellActionType;
  action: CellAction;
}

export enum MetricsEnum {
  biomass = 'biomass',
  count = 'count',
  feedAmount = 'feedAmount',
}

export enum ContextEnum {
  growthMortalityLice = 'Growth/Mortality/Lice',
  cvQuality = 'CV/Quality',
}

export declare type OverviewTableFishGroupProcessed = Omit<FishGroup, 'startDate' | 'endDate'> & {
  startDate: Date;
  endDate: Date;
};
